import { find, upperCase } from 'lodash'
import React, { ReactElement } from 'react'
import { components } from 'react-select'
import styled from 'styled-components'

import Select from '../Select'
import { LANGUAGE_OPTIONS } from '.'

type LanguageSelectComponentProps = {
  options?: any[]
  flagSize?: number | string
  useShortCode?: boolean
  hideCountryText?: boolean
  flagsOnly?: boolean
  value?: string
  onChange: ({ value }) => void
  useDarkMode?: boolean
  flipLeft?: boolean
  useMinWidth?: boolean
}

type TWrapper = {
  flagsOnly?: boolean
  useMinWidth?: boolean
}

const Wrapper = styled.div<TWrapper>`
  min-width: ${({ flagsOnly, useMinWidth }) =>
    useMinWidth ? '100%' : flagsOnly ? '70px' : '180px'};

  @media (max-width: 375px) {
    min-width: ${({ useMinWidth }) => (useMinWidth ? '100%' : '100px')};
  }
`

export const LanguageSelectComponent = (
  props: LanguageSelectComponentProps,
): ReactElement => {
  const {
    options: pOptions,
    flagSize,
    useShortCode,
    hideCountryText,
    flagsOnly,
    value,
    onChange,
    useDarkMode,
    flipLeft,
    useMinWidth,
  } = props

  const options = pOptions || LANGUAGE_OPTIONS

  const IndicatorSeparator = (): React.ReactElement => <div />

  const Option = (subProps: any): React.ReactElement => {
    const { label, value, flag } = subProps.data
    return (
      <components.Option {...subProps}>
        <div style={{ whiteSpace: 'nowrap' }}>
          <i
            className={`flag-icon flag-icon-${flag}`}
            style={{ fontSize: flagSize }}
          />
          <span> {useShortCode ? upperCase(value) : label}</span>
        </div>
      </components.Option>
    )
  }

  const SingleValue = (subProps: any): React.ReactElement => {
    const { label, value, flag } = subProps.data
    return (
      <components.SingleValue {...subProps}>
        <div style={{ whiteSpace: 'nowrap' }}>
          <i
            className={`flag-icon flag-icon-${flag}`}
            style={{ fontSize: flagSize }}
          />
          {hideCountryText || flagsOnly ? null : (
            <span> {useShortCode ? upperCase(value) : label}</span>
          )}
        </div>
      </components.SingleValue>
    )
  }

  return (
    <Wrapper flagsOnly={flagsOnly} useMinWidth={useMinWidth}>
      <Select
        name="language"
        components={{ IndicatorSeparator, SingleValue, Option }}
        value={find(options, (o) => o.value === value)}
        onChange={onChange}
        options={options}
        searchable={false}
        clearable={false}
        isSearchable={false}
        autosize
        menuPlacement="auto"
        useBody
        theme={(theme) => {
          if (useDarkMode) {
            return {
              ...theme,
              colors: {
                ...theme.colors,
                neutral5: 'black',
                neutral10: 'black',
                neutral20: 'black',
                neutral30: 'black',
                neutral40: 'black',
                neutral50: 'black',
                neutral60: 'black',
                neutral70: 'black',
                neutral80: 'black',
                neutral90: 'black',
              },
            }
          }
          return { ...theme }
        }}
        styles={{
          container: (provided: any) => ({
            ...provided,
            width: hideCountryText ? 68 : 180,
          }),
          menu: (provided: any) => ({
            ...provided,
            width: 150,
            ...(flipLeft && { right: '0px' }),
          }),
        }}
      />
    </Wrapper>
  )
}
